import { css } from '@emotion/react';

const EquityBoxStyles = css`
    .row {
        display: flex;
        margin: 0;
        width: 100%;
    }

    .box {
        border: 1px solid black;
        width: 25%;

        &.selected {
            background-color: green;
        }
    }

    .box:after {
        content: '';
        display: block;
        padding-bottom: 100%;
    }

    .labels-x,
    .labels-y {
        border: 1px solid transparent;
        text-align: center;
    }
`;

export const themeEquityBoxStyles = css`
    .row {
        display: flex;
        margin: 0;
        width: 100%;
    }

    .box {
        border: 1px solid var(--color-black);
        width: 25%;

        &.selected {
            background-color: var(--color-equity-box);
        }
    }

    .box:after {
        content: '';
        display: block;
        padding-bottom: 100%;
    }

    .labels-x,
    .labels-y {
        border: 1px solid transparent;
        text-align: center;
    }

    .equity-box-container {
        display: flex;
        background: var(--color-white);
    }

    .equity-box {
        font-family: 'OpenSans-Regular';
        font-size: var(--body-small-fontSize);
        padding-top: 15px;
        padding-left: 50px;
        margin-right: 20px;
    }
    .legend {
        width: 20%;
        font-family: 'OpenSans-Regular';
        font-size: var(--body-small-fontSize);
        margin-top: 15px;
    }
    .box {
        width: 40px;
        height: 40px;
        margin: 1px;
    }
    .labels-y {
        padding: 2px 0 0 0 !important;
        writing-mode: vertical-rl;
        div {
            font-size: var(--body-small-fontSize);
        }
    }
    .labels-x {
        padding: 0px;
        div {
            font-size: var(--body-small-fontSize);
            width: 30px;
        }
    }
    .box:after {
        content: '';
        display: inherit;
        padding-bottom: 0;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        .equity-box {
            padding-left: 0 !important;
        }
    }
`;

export default EquityBoxStyles;
